import { useQuery } from '@tanstack/react-query'
import { CustomersFn } from '../api/getCustomers'

interface CustomersProps {
 cli_id: number
 cli_seo: string
 cli_name: string
}

export function Customers() {
 const { data: customers } = useQuery<CustomersProps[]>({
  queryKey: ['clients'],
  queryFn: CustomersFn,
  staleTime: 1000 * 60 * 60 * 24 // 1 dia
 })

 return (
  <div className="grid max-[415px]:grid-cols-2 max-[768px]:grid-cols-3 min-[768px]:grid-cols-4 min-[992px]:grid-cols-5">
   {customers?.map(customer => {
    return (
     <div
      key={customer.cli_id}
      className="relative flex items-center justify-center w-full aspect-square group"
     >
      <img
       src={`https://www.admancriativa.com.br/assets/img/clientes/${customer.cli_name}`}
       alt={customer.cli_seo}
       title={customer.cli_seo}
       className="object-contain transition-transform duration-300 group-hover:scale-105"
      />
     </div>
    )
   })}
  </div>
 )
}
